module.exports = JSON.parse('{"Measurements":"Измерения","Studies":"Исследования"}')